import { apiPost } from './api';
import type { EntityType } from '../components/EntityChip';

export interface ResolvedEntity {
  type: EntityType;
  id: string;
  title: string;
  snippet: string;
  exists: boolean;
}

export async function resolveEntities(
  items: { type: EntityType; id: string }[],
): Promise<ResolvedEntity[]> {
  if (items.length === 0) return [];
  const { results } = await apiPost<{ results: ResolvedEntity[] }>(
    '/entity-links/resolve', { items },
  );
  return results;
}
